import { jsx as f, jsxs as t2, Fragment as I2 } from "react/jsx-runtime";
import { createContext as c2, useContext as l2, useId as w2, useState as e2, useRef as E, useCallback as q, useEffect as $, cloneElement as X2, forwardRef as D, Children as O2, useLayoutEffect as b2, createElement as g2, useSyncExternalStore as Y2, useMemo as Q2, isValidElement as J2 } from "react";
import { createPortal as e0 } from "react-dom";
function L(...t) {
  return t.filter(Boolean).join(" ");
}
const q2 = c2(!1), H2 = c2("default");
function t0() {
  return l2(H2);
}
const n0 = {
  clearSelection: "Clear selection",
  confirmAction: "Confirm",
  confirmCancel: "Cancel",
  createValue: "Use custom value",
  dialogClose: "Close dialog",
  loading: "Loading",
  noOptions: "No options",
  searchOptions: "Search options",
  selectAll: "Select all",
  selectPlaceholder: "Select an option"
}, o0 = {
  colorScheme: "light",
  contrast: "standard",
  density: "comfortable",
  locale: "en",
  messages: n0,
  tooltipDelay: 450
}, r0 = c2(
  o0
), a0 = c2(null);
function C2() {
  return l2(r0);
}
function P2(t, e) {
  return typeof t == "function" ? t() : t || ((e ?? (typeof document > "u" ? null : document))?.body ?? null);
}
function j2({ children: t, ownerDocument: e, target: n }) {
  const o = C2(), s = P2(
    n === void 0 ? o.portalHost : n,
    e
  );
  return s ? e0(
    /* @__PURE__ */ f(H2.Provider, { value: "default", children: t }),
    s
  ) : null;
}
const s0 = "_root_50nwc_2", i0 = "_arrow_50nwc_3", c0 = "_content_50nwc_4", l0 = "_body_50nwc_5", u2 = {
  root: s0,
  arrow: i0,
  content: c0,
  body: l0
}, d0 = 450, u0 = 400, f0 = 300;
let N2 = 0;
const o2 = /* @__PURE__ */ new WeakMap(), C0 = 12, h0 = 8, r2 = 8, Z = 8;
function p0(t, e) {
  if (t) {
    if (typeof t == "function") {
      t(e);
      return;
    }
    t.current = e;
  }
}
const y0 = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
};
function E2(t, e) {
  switch (e) {
    case "top":
      return t.top - Z;
    case "bottom":
      return window.innerHeight - t.bottom - Z;
    case "left":
      return t.left - Z;
    case "right":
      return window.innerWidth - t.right - Z;
  }
}
function m0(t, e, n) {
  switch (n) {
    case "top":
      return {
        top: t.top - e.height - r2,
        left: t.left + (t.width - e.width) / 2
      };
    case "bottom":
      return {
        top: t.bottom + r2,
        left: t.left + (t.width - e.width) / 2
      };
    case "left":
      return {
        top: t.top + (t.height - e.height) / 2,
        left: t.left - e.width - r2
      };
    case "right":
      return {
        top: t.top + (t.height - e.height) / 2,
        left: t.right + r2
      };
  }
}
function v0(t, e, n) {
  const o = n === "top" || n === "bottom" ? e.height + r2 : e.width + r2, s = E2(t, n);
  if (s >= o) return n;
  const a = y0[n], l = E2(t, a);
  return l >= o || l > s ? a : n;
}
function L2(t, e) {
  let { top: n, left: o } = t;
  return o < Z ? o = Z : o + e.width > window.innerWidth - Z && (o = window.innerWidth - e.width - Z), n < Z ? n = Z : n + e.height > window.innerHeight - Z && (n = window.innerHeight - e.height - Z), { top: n, left: o };
}
function k0({
  children: t,
  className: e,
  content: n,
  delay: o,
  disabled: s = !1,
  followCursor: a = !1,
  interactive: l = !1,
  placement: u = "top",
  trigger: i = "hover",
  triggerRef: C,
  active: y = !1,
  onBeforeShow: w
}) {
  const m = C2(), b = o ?? m.tooltipDelay ?? d0, v = w2(), [h, g] = e2(!1), [A, V] = e2({
    top: 0,
    left: 0,
    placement: u,
    ready: !1
  }), [R, B] = e2(null), F = E(null), p = C ?? F, H = E(null), T = E(null), k = E(null), z = E(null), P = E(null), X = E(!1), W = E(() => {
  }), d = q(() => {
    if (!H.current) return;
    const r = H.current.getBoundingClientRect();
    if (a && R) {
      const Y = {
        top: R.y + h0,
        left: R.x + C0
      }, s2 = L2(Y, r);
      V({ top: s2.top, left: s2.left, placement: "bottom", ready: !0 });
      return;
    }
    if (!p.current) return;
    const x = p.current.getBoundingClientRect(), O = v0(x, r, u), j = L2(
      m0(x, r, O),
      r
    );
    V({ top: j.top, left: j.left, placement: O, ready: !0 });
  }, [u, a, R]), N = q(() => {
    P.current === null && (P.current = requestAnimationFrame(() => {
      P.current = null, d();
    }));
  }, [d]), M = q((r) => {
    if (s) return;
    const x = p.current;
    if (!x || x.closest('[hidden], [aria-hidden="true"]') || w && !w()) return;
    T.current && clearTimeout(T.current), k.current && (clearTimeout(k.current), k.current = null), a && r && (z.current = { x: r.clientX, y: r.clientY });
    const O = (i === "hover" || i === "hover-focus") && Date.now() < N2 ? 0 : b;
    X.current = O === 0, T.current = setTimeout(() => {
      if (T.current = null, !x.isConnected || x.closest('[hidden], [aria-hidden="true"]') || w && !w()) return;
      const j = o2.get(x.ownerDocument);
      j && j.id !== v && j.hide(), o2.set(x.ownerDocument, { id: v, hide: () => W.current() }), a && B(z.current), V((Y) => Y.ready ? { ...Y, ready: !1 } : Y), g(!0);
    }, O);
  }, [s, a, w, b, v, i, p]), _ = q(() => {
    T.current && (clearTimeout(T.current), T.current = null), k.current && (clearTimeout(k.current), k.current = null), h && (N2 = Date.now() + f0);
    const r = p.current?.ownerDocument;
    r && o2.get(r)?.id === v && o2.delete(r), g(!1), V((x) => x.ready ? { ...x, ready: !1 } : x), a && (z.current = null, B(null));
  }, [a, v, p, h]);
  $(() => {
    W.current = _;
  }, [_]);
  const S = q(() => {
    if (!l || !h) {
      _();
      return;
    }
    k.current && clearTimeout(k.current), k.current = setTimeout(() => {
      k.current = null, _();
    }, u0);
  }, [_, l, h]);
  $(() => {
    V((r) => r.placement === u ? r : { ...r, placement: u });
  }, [u]), $(() => {
    s && _();
  }, [s, _]), $(() => {
    if (h)
      return N(), a || window.addEventListener("scroll", N, { capture: !0, passive: !0 }), window.addEventListener("resize", N, { passive: !0 }), () => {
        a || window.removeEventListener("scroll", N, { capture: !0 }), window.removeEventListener("resize", N), P.current !== null && (cancelAnimationFrame(P.current), P.current = null);
      };
  }, [h, a, N]), $(() => {
    const r = p.current?.ownerDocument;
    return () => {
      T.current && clearTimeout(T.current), k.current && clearTimeout(k.current), r && o2.get(r)?.id === v && o2.delete(r);
    };
  }, [v, p]), $(() => {
    const r = C?.current;
    if (!r) return;
    const x = (J) => {
      (i === "hover" || i === "hover-focus") && M(J);
    }, O = (J) => {
      l && J.relatedTarget instanceof Node && H.current?.contains(J.relatedTarget) || i === "hover-focus" && r.contains(r.ownerDocument.activeElement) || (i === "hover" || i === "hover-focus") && S();
    }, j = () => {
      (i === "focus" || i === "hover-focus") && M();
    }, Y = (J) => {
      J.relatedTarget && r.contains(J.relatedTarget) || (i === "focus" || i === "hover-focus") && _();
    }, s2 = () => {
      i === "click" && !h ? M() : _();
    };
    return r.addEventListener("mouseenter", x), r.addEventListener("mouseleave", O), r.addEventListener("focusin", j), r.addEventListener("focusout", Y), r.addEventListener("click", s2), () => {
      r.removeEventListener("mouseenter", x), r.removeEventListener("mouseleave", O), r.removeEventListener("focusin", j), r.removeEventListener("focusout", Y), r.removeEventListener("click", s2);
    };
  }, [C, _, l, S, M, i, h]);
  const Q = E(!1);
  $(() => {
    const r = p.current, x = !s && (y || !!(C && r?.contains(r.ownerDocument.activeElement)));
    x !== Q.current && (Q.current = x, x ? M() : _());
  }, [y, s, C, _, M, p]), $(() => {
    const r = p.current?.ownerDocument, x = (O) => {
      O.key === "Escape" && _();
    };
    return r?.addEventListener("keydown", x, !0), () => r?.removeEventListener("keydown", x, !0);
  }, [_, p]);
  const I = t?.props ?? {}, n2 = t?.ref, h2 = q((r) => {
    F.current = r, p0(n2, r);
  }, [n2]), p2 = (r) => {
    (i === "hover" || i === "hover-focus") && M(r), I.onMouseEnter?.(r);
  }, a2 = (r) => {
    (i === "hover" || i === "hover-focus" && !r.currentTarget.contains(r.currentTarget.ownerDocument.activeElement)) && S(), I.onMouseLeave?.(r);
  }, U = (r) => {
    a && !h && (z.current = { x: r.clientX, y: r.clientY }), I.onMouseMove?.(r);
  }, R2 = (r) => {
    T.current && (clearTimeout(T.current), T.current = null), h ? _() : i === "click" && M(), I.onClick?.(r);
  }, W2 = (r) => {
    (i === "focus" || i === "hover-focus") && M(), I.onFocus?.(r);
  }, K2 = (r) => {
    (i === "focus" || i === "hover-focus") && _(), I.onBlur?.(r);
  }, d2 = h && A.ready;
  $(() => {
    const r = C?.current;
    if (!r || !d2) return;
    const x = new Set(r.getAttribute("aria-describedby")?.split(/\s+/).filter(Boolean));
    return x.add(v), r.setAttribute("aria-describedby", [...x].join(" ")), () => {
      const O = r.getAttribute("aria-describedby")?.split(/\s+/).filter((j) => j && j !== v) ?? [];
      O.length ? r.setAttribute("aria-describedby", O.join(" ")) : r.removeAttribute("aria-describedby");
    };
  }, [C, d2, v]);
  const G2 = t ? X2(t, {
    ref: h2,
    onMouseEnter: p2,
    onMouseLeave: a2,
    onMouseMove: a ? U : I.onMouseMove,
    onClick: R2,
    onFocus: W2,
    onBlur: K2,
    "aria-describedby": d2 ? [I["aria-describedby"], v].filter(Boolean).join(" ") : I["aria-describedby"]
  }) : null;
  return /* @__PURE__ */ t2(I2, { children: [
    /* @__PURE__ */ f(q2.Provider, { value: !s, children: G2 }),
    h && /* @__PURE__ */ f(j2, { ownerDocument: p.current?.ownerDocument, children: /* @__PURE__ */ t2(
      "div",
      {
        ref: H,
        id: v,
        role: "tooltip",
        "data-openbitfun-native-webview-occlusion": !0,
        className: L(u2.root, e),
        "data-openbitfun-component": "tooltip",
        "data-openbitfun-placement": A.placement,
        "data-openbitfun-interactive": l ? "true" : "false",
        "data-openbitfun-state": d2 ? "visible" : void 0,
        "data-instant": X.current || void 0,
        onClick: (r) => r.stopPropagation(),
        onMouseEnter: l ? () => {
          k.current && (clearTimeout(k.current), k.current = null);
        } : void 0,
        onMouseLeave: l ? S : void 0,
        style: {
          top: `${A.top}px`,
          left: `${A.left}px`
        },
        children: [
          !a && /* @__PURE__ */ f("div", { className: u2.arrow, "data-openbitfun-part": "arrow", "aria-hidden": "true" }),
          /* @__PURE__ */ f("div", { className: u2.content, "data-openbitfun-part": "content", children: /* @__PURE__ */ f("div", { className: u2.body, "data-openbitfun-part": "body", children: n }) })
        ]
      }
    ) })
  ] });
}
const w0 = "_root_1rfke_2", g0 = "_content_1rfke_15", $2 = {
  root: w0,
  content: g0
}, _0 = typeof window > "u" ? $ : b2;
function b0(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
const x0 = 2400, M0 = 36, Z2 = D(
  function({
    as: e = "span",
    behavior: n,
    children: o,
    className: s,
    lines: a,
    marqueeActive: l = !1,
    marqueeTrigger: u = "interaction-or-active",
    overflowStyle: i = "fade",
    style: C,
    title: y,
    ...w
  }, m) {
    const b = O2.toArray(o).every(
      (d) => typeof d == "string" || typeof d == "number"
    ), v = a ? "fade" : n ?? (b ? "marquee" : "fade"), h = E(null), g = E(null), A = E(null), V = l2(q2), [R, B] = e2(""), F = E({
      distance: 0,
      isOverflowing: !1
    }), [p, H] = e2(F.current), T = q((d) => {
      h.current = d, A.current = d?.closest("[data-overflow-trigger]") ?? d, b0(m, d);
    }, [m]), k = q(() => {
      const d = h.current, N = g.current ?? d;
      if (!d || !N) return;
      const M = Math.max(0, N.scrollWidth - d.clientWidth), _ = a !== void 0 && d.clientHeight > 0 && d.scrollHeight > d.clientHeight, S = d.clientWidth > 0 && (M > 0 || _), Q = F.current;
      if (Q.distance === M && Q.isOverflowing === S) return;
      const I = { distance: M, isOverflowing: S };
      F.current = I, H(I);
    }, [a]), z = q(() => {
      const d = h.current, N = A.current;
      if (!d || !N) return !1;
      const M = N === d ? [d] : Array.from(N.querySelectorAll('[data-overflow-tooltip="true"]')).filter((S) => S.closest("[data-overflow-trigger]") === N && !S.querySelector('[data-overflow-tooltip="true"]'));
      if (M[0] !== d) return !1;
      const _ = M.map((S) => S.getAttribute("data-overflow-text") ?? S.textContent ?? "").filter(Boolean).join(`
`);
      return _ ? (B(_), !0) : !1;
    }, []);
    _0(() => {
      k();
    }, [v, o, a, i, k]), $(() => {
      F.current.isOverflowing && z();
    }, [o, y, z]), $(() => {
      const d = h.current;
      if (!d) return;
      const N = typeof ResizeObserver > "u" ? null : new ResizeObserver(k);
      N?.observe(d), g.current && N?.observe(g.current);
      const M = d.ownerDocument.fonts;
      M?.addEventListener("loadingdone", k);
      const _ = b || typeof MutationObserver > "u" ? null : new MutationObserver(() => {
        k(), z();
      });
      return _?.observe(d, { childList: !0, characterData: !0, subtree: !0 }), N || d.ownerDocument.defaultView?.addEventListener("resize", k), () => {
        N?.disconnect(), _?.disconnect(), M?.removeEventListener("loadingdone", k), N || d.ownerDocument.defaultView?.removeEventListener("resize", k);
      };
    }, [v, i, z, b, k]);
    const P = Math.max(
      x0,
      Math.round(p.distance / M0 * 1e3)
    ), X = {
      ...C,
      ...a ? { "--_overflow-text-lines": a } : {},
      ...v === "marquee" ? {
        "--_overflow-text-marquee-distance": `${p.distance}px`,
        "--_overflow-text-marquee-duration": `${P}ms`
      } : {}
    }, W = p.isOverflowing && !V && y !== "";
    return /* @__PURE__ */ t2(I2, { children: [
      /* @__PURE__ */ f(
        e,
        {
          ...w,
          className: L($2.root, s),
          "data-marquee-active": l && u !== "interaction" ? "true" : void 0,
          "data-marquee-trigger": u,
          "data-overflow": p.isOverflowing ? "true" : "false",
          "data-overflow-behavior": v,
          "data-overflow-lines": a,
          "data-overflow-style": a ? void 0 : i,
          "data-overflow-tooltip": W ? "true" : void 0,
          "data-overflow-text": y,
          ref: T,
          style: X,
          title: W ? void 0 : y,
          children: v === "marquee" || (b || i === "ellipsis") && a === void 0 ? /* @__PURE__ */ f("span", { className: $2.content, "data-openbitfun-part": "content", "data-overflow-content": "", ref: g, children: o }) : o
        }
      ),
      W && /* @__PURE__ */ f(
        k0,
        {
          active: l && u !== "interaction",
          content: R,
          interactive: !0,
          onBeforeShow: z,
          trigger: "hover-focus",
          triggerRef: A
        }
      )
    ] });
  }
);
const N0 = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), E0 = (t) => t.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (e, n, o) => o ? o.toUpperCase() : n.toLowerCase()
), D2 = (t) => {
  const e = E0(t);
  return e.charAt(0).toUpperCase() + e.slice(1);
}, V2 = (...t) => t.filter((e, n, o) => !!e && e.trim() !== "" && o.indexOf(e) === n).join(" ").trim(), L0 = (t) => {
  for (const e in t)
    if (e.startsWith("aria-") || e === "role" || e === "title")
      return !0;
};
var $0 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const D0 = D(
  ({
    color: t = "currentColor",
    size: e = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: o,
    className: s = "",
    children: a,
    iconNode: l,
    ...u
  }, i) => g2(
    "svg",
    {
      ref: i,
      ...$0,
      width: e,
      height: e,
      stroke: t,
      strokeWidth: o ? Number(n) * 24 / Number(e) : n,
      className: V2("lucide", s),
      ...!a && !L0(u) && { "aria-hidden": "true" },
      ...u
    },
    [
      ...l.map(([C, y]) => g2(C, y)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
const c = (t, e) => {
  const n = D(
    ({ className: o, ...s }, a) => g2(D0, {
      ref: a,
      iconNode: e,
      className: V2(
        `lucide-${N0(D2(t))}`,
        `lucide-${t}`,
        o
      ),
      ...s
    })
  );
  return n.displayName = D2(t), n;
};
const A0 = [
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }],
  ["path", { d: "M10 4v4", key: "pp8u80" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["path", { d: "M6 4v4", key: "1svtjw" }]
], S0 = c("app-window", A0);
const T0 = [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
], A2 = c("arrow-down", T0);
const z0 = [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
], I0 = c("arrow-left", z0);
const O0 = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
], q0 = c("arrow-right", O0);
const H0 = [
  ["path", { d: "M7 7h10v10", key: "1tivn9" }],
  ["path", { d: "M7 17 17 7", key: "1vkiza" }]
], P0 = c("arrow-up-right", H0);
const j0 = [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
], Z0 = c("arrow-up", j0);
const V0 = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ]
], B0 = c("bell", V0);
const F0 = [
  [
    "path",
    {
      d: "M10 22V7a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5a1 1 0 0 0-1-1H2",
      key: "1ah6g2"
    }
  ],
  ["rect", { x: "14", y: "2", width: "8", height: "8", rx: "1", key: "88lufb" }]
], U0 = c("blocks", F0);
const R0 = [
  ["path", { d: "M12 18V5", key: "adv99a" }],
  ["path", { d: "M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4", key: "1e3is1" }],
  ["path", { d: "M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5", key: "1gqd8o" }],
  ["path", { d: "M17.997 5.125a4 4 0 0 1 2.526 5.77", key: "iwvgf7" }],
  ["path", { d: "M18 18a4 4 0 0 0 2-7.464", key: "efp6ie" }],
  ["path", { d: "M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517", key: "1gq6am" }],
  ["path", { d: "M6 18a4 4 0 0 1-2-7.464", key: "k1g0md" }],
  ["path", { d: "M6.003 5.125a4 4 0 0 0-2.526 5.77", key: "q97ue3" }]
], W0 = c("brain", R0);
const K0 = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], G0 = c("check", K0);
const X0 = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], Y0 = c("chevron-down", X0);
const Q0 = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], J0 = c("chevron-left", Q0);
const e1 = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], t1 = c("chevron-right", e1);
const n1 = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], o1 = c("chevron-up", n1);
const r1 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], St = c("circle-alert", r1);
const a1 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], y2 = c("circle-check", a1);
const s1 = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], m2 = c("circle", s1);
const i1 = [
  ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], c1 = c("clock", i1);
const l1 = [
  [
    "path",
    { d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3", key: "11bfej" }
  ]
], d1 = c("command", l1);
const u1 = [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], f1 = c("copy", u1);
const C1 = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
], h1 = c("ellipsis", C1);
const p1 = [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], y1 = c("eye", p1);
const m1 = [
  [
    "path",
    {
      d: "M15 2a2 2 0 0 1 1.414.586l4 4A2 2 0 0 1 21 8v7a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z",
      key: "1vo8kb"
    }
  ],
  ["path", { d: "M15 2v4a2 2 0 0 0 2 2h4", key: "sud9ri" }],
  ["path", { d: "M5 7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 1.732-1", key: "l4dndm" }]
], v1 = c("files", m1);
const k1 = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
], w1 = c("folder", k1);
const g1 = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["line", { x1: "3", x2: "9", y1: "12", y2: "12", key: "1dyftd" }],
  ["line", { x1: "15", x2: "21", y1: "12", y2: "12", key: "oup4p8" }]
], _1 = c("git-commit-horizontal", g1);
const b1 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
], x1 = c("globe", b1);
const M1 = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
], N1 = c("image", M1);
const E1 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], L1 = c("info", E1);
const $1 = [
  ["path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", key: "1cjeqo" }],
  ["path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71", key: "19qd67" }]
], D1 = c("link", $1);
const A1 = [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
], S1 = c("list-filter", A1);
const T1 = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], z1 = c("loader-circle", T1);
const I1 = [
  [
    "path",
    {
      d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
      key: "1sd12s"
    }
  ]
], O1 = c("message-circle", I1);
const q1 = [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
      key: "18887p"
    }
  ],
  ["path", { d: "M12 8v6", key: "1ib9pf" }],
  ["path", { d: "M9 11h6", key: "1fldmi" }]
], H1 = c("message-square-plus", q1);
const P1 = [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
      key: "18887p"
    }
  ],
  ["path", { d: "M7 11h10", key: "1twpyw" }],
  ["path", { d: "M7 15h6", key: "d9of3u" }],
  ["path", { d: "M7 7h8", key: "af5zfr" }]
], j1 = c("message-square-text", P1);
const Z1 = [
  [
    "path",
    {
      d: "M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z",
      key: "1n2ejm"
    }
  ],
  [
    "path",
    {
      d: "M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1",
      key: "1qfcsi"
    }
  ]
], V1 = c("messages-square", Z1);
const B1 = [
  ["path", { d: "M12 19v3", key: "npa21l" }],
  ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2", key: "1vc78b" }],
  ["rect", { x: "9", y: "2", width: "6", height: "13", rx: "3", key: "s6n7sd" }]
], F1 = c("mic", B1);
const U1 = [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
], R1 = c("monitor", U1);
const W1 = [
  [
    "path",
    {
      d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
      key: "e79jfc"
    }
  ],
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }]
], K1 = c("palette", W1);
const G1 = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
], X1 = c("panel-left", G1);
const Y1 = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], Q1 = c("panel-right", Y1);
const J1 = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], ee = c("pencil", J1);
const te = [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  [
    "path",
    {
      d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
      key: "1nkz8b"
    }
  ]
], ne = c("pin", te);
const oe = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], re = c("plus", oe);
const ae = [
  [
    "path",
    {
      d: "M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z",
      key: "w46dr5"
    }
  ]
], se = c("puzzle", ae);
const ie = [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
], ce = c("refresh-cw", ie);
const le = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], de = c("search", le);
const ue = [
  [
    "path",
    {
      d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
      key: "1i5ecw"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], fe = c("settings", ue);
const Ce = [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
], he = c("sliders-horizontal", Ce);
const pe = [
  ["line", { x1: "4", x2: "4", y1: "21", y2: "14", key: "1p332r" }],
  ["line", { x1: "4", x2: "4", y1: "10", y2: "3", key: "gb41h5" }],
  ["line", { x1: "12", x2: "12", y1: "21", y2: "12", key: "hf2csr" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "3", key: "1kfi7u" }],
  ["line", { x1: "20", x2: "20", y1: "21", y2: "16", key: "1lhrwl" }],
  ["line", { x1: "20", x2: "20", y1: "12", y2: "3", key: "16vvfq" }],
  ["line", { x1: "2", x2: "6", y1: "14", y2: "14", key: "1uebub" }],
  ["line", { x1: "10", x2: "14", y1: "8", y2: "8", key: "1yglbp" }],
  ["line", { x1: "18", x2: "22", y1: "16", y2: "16", key: "1jxqpz" }]
], ye = c("sliders-vertical", pe);
const me = [
  [
    "path",
    {
      d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
      key: "1s2grr"
    }
  ],
  ["path", { d: "M20 2v4", key: "1rf3ol" }],
  ["path", { d: "M22 4h-4", key: "gwowj6" }],
  ["circle", { cx: "4", cy: "20", r: "2", key: "6kqj1y" }]
], ve = c("sparkles", me);
const ke = [
  [
    "path",
    {
      d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
      key: "r04s7s"
    }
  ]
], we = c("star", ke);
const ge = [
  ["path", { d: "M15 21v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5", key: "slp6dd" }],
  [
    "path",
    {
      d: "M17.774 10.31a1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.451 0 1.12 1.12 0 0 0-1.548 0 2.5 2.5 0 0 1-3.452 0 1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.77-3.248l2.889-4.184A2 2 0 0 1 7 2h10a2 2 0 0 1 1.653.873l2.895 4.192a2.5 2.5 0 0 1-3.774 3.244",
      key: "o0xfot"
    }
  ],
  ["path", { d: "M4 10.95V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.05", key: "wn3emo" }]
], _e = c("store", ge);
const be = [
  ["path", { d: "M12 19h8", key: "baeox8" }],
  ["path", { d: "m4 17 6-6-6-6", key: "1yngyt" }]
], xe = c("terminal", be);
const Me = [
  ["path", { d: "M10 11v6", key: "nco0om" }],
  ["path", { d: "M14 11v6", key: "outv1u" }],
  ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", key: "miytrc" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", key: "e791ji" }]
], Ne = c("trash-2", Me);
const Ee = [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], Tt = c("triangle-alert", Ee);
const Le = [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m17 8-5-5-5 5", key: "7q97r8" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }]
], $e = c("upload", Le);
const De = [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
], Ae = c("user", De);
const Se = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], Te = c("x", Se), ze = "_button_10cmt_2", Ie = "_content_10cmt_218", Oe = "_label_10cmt_227", qe = "_staticLabel_10cmt_241", He = "_icon_10cmt_248", Pe = "_leadingIcon_10cmt_264", je = "_trailingIcon_10cmt_269", Ze = "_progress_10cmt_279", K = {
  button: ze,
  content: Ie,
  label: Oe,
  staticLabel: qe,
  icon: He,
  leadingIcon: Pe,
  trailingIcon: je,
  progress: Ze
}, zt = D(function({
  children: e,
  className: n,
  disabled: o,
  labelBehavior: s = "overflow",
  leadingIcon: a,
  loading: l = !1,
  size: u = "md",
  tone: i = "neutral",
  trailingIcon: C,
  type: y = "button",
  variant: w = "outline",
  ...m
}, b) {
  return /* @__PURE__ */ t2(
    "button",
    {
      "data-overflow-trigger": !0,
      ...m,
      "aria-busy": l || void 0,
      className: L(K.button, n),
      "data-openbitfun-component": "button",
      "data-openbitfun-part": "root",
      "data-openbitfun-tone": i,
      "data-openbitfun-variant": w,
      "data-loading": l ? "true" : "false",
      "data-label-behavior": s,
      "data-size": u,
      disabled: o || l,
      ref: b,
      type: y,
      children: [
        /* @__PURE__ */ f("span", { "aria-hidden": "true", className: K.progress, "data-openbitfun-part": "progress" }),
        /* @__PURE__ */ t2("span", { className: K.content, "data-openbitfun-part": "content", children: [
          a && /* @__PURE__ */ f("span", { "aria-hidden": "true", className: L(K.icon, K.leadingIcon), "data-openbitfun-part": "leading-icon", children: a }),
          s === "static" ? /* @__PURE__ */ f("span", { className: L(K.label, K.staticLabel), "data-openbitfun-part": "label", children: e }) : /* @__PURE__ */ f(Z2, { className: K.label, "data-openbitfun-part": "label", children: e }),
          C && /* @__PURE__ */ f("span", { "aria-hidden": "true", className: L(K.icon, K.trailingIcon), "data-openbitfun-part": "trailing-icon", children: C })
        ] })
      ]
    }
  );
});
function B2(t, e = !1) {
  return e || t.isComposing === !0 || t.keyCode === 229 || t.nativeEvent?.isComposing === !0 || t.nativeEvent?.keyCode === 229;
}
const Ve = "_field_h92xi_2", Be = "_leading_h92xi_50", Fe = "_trailing_h92xi_50", Ue = "_input_h92xi_59", f2 = {
  field: Ve,
  leading: Be,
  trailing: Fe,
  input: Ue
}, It = D(function({
  "aria-invalid": e,
  className: n,
  disabled: o,
  hideNativePasswordReveal: s = !1,
  invalid: a = !1,
  leading: l,
  onChange: u,
  onCompositionEnd: i,
  onCompositionStart: C,
  onKeyDown: y,
  onValueChange: w,
  size: m = "sm",
  trailing: b,
  type: v = "text",
  ...h
}, g) {
  const A = E(!1), V = t0(), R = (p) => {
    u?.(p), w?.(p.currentTarget.value);
  }, B = a ? !0 : e, F = B !== void 0 && B !== !1 && B !== "false";
  return /* @__PURE__ */ t2(
    "span",
    {
      className: L(f2.field, n),
      "data-openbitfun-component": "input",
      "data-disabled": o ? "true" : "false",
      "data-field-surface": V,
      "data-invalid": F ? "true" : "false",
      "data-size": m,
      children: [
        l != null && /* @__PURE__ */ f("span", { className: f2.leading, "data-openbitfun-part": "leading", children: l }),
        /* @__PURE__ */ f(
          "input",
          {
            ...h,
            "aria-invalid": B,
            className: f2.input,
            "data-hide-native-password-reveal": s ? "true" : void 0,
            disabled: o,
            onChange: R,
            onCompositionEnd: (p) => {
              A.current = !1, i?.(p);
            },
            onCompositionStart: (p) => {
              A.current = !0, C?.(p);
            },
            onKeyDown: (p) => {
              if ((p.key === "Enter" || p.key === "Escape") && B2(p, A.current)) {
                p.stopPropagation();
                return;
              }
              y?.(p);
            },
            ref: g,
            type: v
          }
        ),
        b != null && /* @__PURE__ */ f("span", { className: f2.trailing, "data-openbitfun-part": "trailing", children: b })
      ]
    }
  );
}), Re = "_button_av79j_2", We = "_icon_av79j_138", Ke = "_progress_av79j_139", v2 = {
  button: Re,
  icon: We,
  progress: Ke
}, Ge = D(function({
  "aria-label": e,
  className: n,
  disabled: o,
  icon: s,
  loading: a = !1,
  shape: l = "square",
  size: u = "sm",
  tone: i = "neutral",
  type: C = "button",
  variant: y = "quiet",
  ...w
}, m) {
  return /* @__PURE__ */ t2(
    "button",
    {
      ...w,
      "aria-busy": a || void 0,
      "aria-label": e,
      className: L(v2.button, n),
      "data-openbitfun-component": "icon-button",
      "data-openbitfun-shape": l,
      "data-openbitfun-tone": i,
      "data-openbitfun-variant": y,
      "data-loading": a ? "true" : "false",
      "data-size": u,
      disabled: o || a,
      ref: m,
      type: C,
      children: [
        /* @__PURE__ */ f("span", { "aria-hidden": "true", className: v2.progress, "data-openbitfun-part": "progress" }),
        /* @__PURE__ */ f("span", { "aria-hidden": "true", className: v2.icon, "data-openbitfun-part": "icon", children: s })
      ]
    }
  );
}), Xe = "data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20overflow='visible'%20style='display:%20block;'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='HarmonyOS%20Icon'%3e%3cpath%20id='Union'%20d='M17.5%202.25C19.2949%202.25%2020.75%203.70507%2020.75%205.5C20.75%207.03664%2019.6831%208.3224%2018.25%208.66113V10C18.25%2011.5188%2017.0188%2012.75%2015.5%2012.75H8.5C7.80964%2012.75%207.25%2013.3096%207.25%2014V15.3379C8.68325%2015.6765%209.75%2016.9633%209.75%2018.5C9.75%2020.2949%208.29493%2021.75%206.5%2021.75C4.70507%2021.75%203.25%2020.2949%203.25%2018.5C3.25%2016.9633%204.31675%2015.6765%205.75%2015.3379V8.66113C4.31686%208.3224%203.25%207.03664%203.25%205.5C3.25%203.70507%204.70507%202.25%206.5%202.25C8.29493%202.25%209.75%203.70507%209.75%205.5C9.75%207.03664%208.68314%208.3224%207.25%208.66113V11.5527C7.62532%2011.3606%208.04942%2011.25%208.5%2011.25H15.5C16.1904%2011.25%2016.75%2010.6904%2016.75%2010V8.66113C15.3169%208.3224%2014.25%207.03664%2014.25%205.5C14.25%203.70507%2015.7051%202.25%2017.5%202.25ZM6.5%2016.75C5.5335%2016.75%204.75%2017.5335%204.75%2018.5C4.75%2019.4665%205.5335%2020.25%206.5%2020.25C7.4665%2020.25%208.25%2019.4665%208.25%2018.5C8.25%2017.5335%207.4665%2016.75%206.5%2016.75ZM6.5%203.75C5.5335%203.75%204.75%204.5335%204.75%205.5C4.75%206.4665%205.5335%207.25%206.5%207.25C7.4665%207.25%208.25%206.4665%208.25%205.5C8.25%204.5335%207.4665%203.75%206.5%203.75ZM17.5%203.75C16.5335%203.75%2015.75%204.5335%2015.75%205.5C15.75%206.4665%2016.5335%207.25%2017.5%207.25C18.4665%207.25%2019.25%206.4665%2019.25%205.5C19.25%204.5335%2018.4665%203.75%2017.5%203.75Z'%20fill='currentColor'/%3e%3c/g%3e%3c/svg%3e", Ye = "data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20overflow='visible'%20style='display:%20block;'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='HarmonyOS%20Icon'%3e%3cpath%20id='Vector'%20d='M1.55159%2019.6419C3.368%2022.0931%207.17659%2022.7572%209.53987%2020.9994C11.5613%2019.5052%2011.991%2017.1517%2010.4969%2015.1791C9.10042%2013.3041%207.0301%2012.8451%205.40901%2014.0658C3.88557%2015.2084%204.42268%2016.849%203.57307%2017.4837C2.83089%2018.0404%202.13753%2017.7279%201.60042%2018.138C1.2098%2018.4505%201.08284%2019.0169%201.55159%2019.6419ZM3.54378%2019.4857C3.41682%2019.349%203.42659%2019.2123%203.51448%2019.1244C3.6512%2018.9974%204.19807%2018.9584%204.618%2018.5384C5.56526%2017.6009%205.243%2016.224%206.33675%2015.3744C7.24495%2014.6517%208.50471%2014.9154%209.35432%2016.0091C10.3114%2017.2494%209.97932%2018.763%208.66096%2019.7787C7.18635%2020.9408%204.91096%2020.931%203.54378%2019.4857ZM11.1024%2017.3177C12.157%2017.2005%2013.0457%2016.6732%2014.0418%2015.6771C17.1766%2012.5521%2021.9617%205.55011%2022.3817%204.96417C23.6121%203.25519%2021.5028%201.16534%2019.784%202.36651C19.2078%202.77667%2012.1961%207.55206%209.07112%2010.7064C8.09456%2011.6927%207.55745%2012.5716%207.4305%2013.6068L8.9637%2014.0267C8.98323%2013.3138%209.36409%2012.6205%2010.1746%2011.8197C13.2703%208.763%2020.116%204.06573%2020.536%203.75323C20.868%203.50909%2021.2391%203.86066%2020.9852%204.22198C20.7313%204.59308%2015.9754%2011.5267%2012.9285%2014.5736C12.1278%2015.3744%2011.5125%2015.6966%2010.8387%2015.7748L11.1024%2017.3177ZM12.8309%2014.8666L14.0809%2014.5443C13.9442%2012.6791%2012.118%2010.8235%2010.2821%2010.6673L9.86214%2011.9173C11.1121%2011.888%2012.8309%2013.6068%2012.8309%2014.8666Z'%20fill='currentColor'/%3e%3c/g%3e%3c/svg%3e", Qe = "data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20overflow='visible'%20style='display:%20block;'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='HarmonyOS%20Icon'%3e%3cpath%20id='Union'%20d='M8.65247%2015.4862C8.74541%2015.4897%208.83214%2015.5262%208.89563%2015.5897C8.95912%2015.6532%208.99566%2015.7399%208.99915%2015.8329C9.00254%2015.9259%208.97198%2016.017%208.922%2016.0936C8.84739%2016.2075%208.77136%2016.3209%208.69544%2016.4335C7.63224%2018.0099%206.44102%2019.4584%205.12122%2020.7782C4.74415%2021.1552%204.27269%2021.4373%203.70715%2021.6259C3.56583%2021.673%203.41884%2021.7155%203.26575%2021.7509C3.18121%2021.7697%203.09401%2021.7824%203.01184%2021.7733C2.92979%2021.7641%202.85864%2021.7324%202.80579%2021.6796C2.75295%2021.6267%202.72121%2021.5556%202.71204%2021.4735C2.70299%2021.3913%202.71563%2021.3041%202.7345%2021.2196C2.76984%2021.0665%202.81239%2020.9195%202.8595%2020.7782C3.04804%2020.2127%203.33015%2019.7412%203.70715%2019.3641C5.02696%2018.0443%206.47548%2016.8531%208.05188%2015.7899C8.16445%2015.714%208.27785%2015.638%208.39172%2015.5634C8.46834%2015.5134%208.55948%2015.4828%208.65247%2015.4862ZM14.8322%2015.4862C14.9253%2015.4827%2015.0172%2015.5133%2015.0939%2015.5634C15.2077%2015.6379%2015.3212%2015.714%2015.4337%2015.7899C17.0101%2016.8531%2018.4587%2018.0444%2019.7784%2019.3641C20.1554%2019.7412%2020.4376%2020.2127%2020.6261%2020.7782C20.6732%2020.9194%2020.7148%2021.0666%2020.7501%2021.2196C20.769%2021.3041%2020.7826%2021.3913%2020.7736%2021.4735C20.7644%2021.5555%2020.7326%2021.6267%2020.6798%2021.6796C20.627%2021.7324%2020.5558%2021.7641%2020.4738%2021.7733C20.3916%2021.7824%2020.3044%2021.7697%2020.2198%2021.7509C20.0668%2021.7155%2019.9198%2021.673%2019.7784%2021.6259C19.2129%2021.4373%2018.7414%2021.1552%2018.3644%2020.7782C17.0446%2019.4584%2015.8534%2018.0099%2014.7902%2016.4335C14.7143%2016.3209%2014.6382%2016.2075%2014.5636%2016.0936C14.5136%2016.017%2014.4831%2015.9259%2014.4865%2015.8329C14.4899%2015.7399%2014.5265%2015.6532%2014.59%2015.5897C14.6533%2015.5264%2014.7394%2015.4898%2014.8322%2015.4862ZM12.0001%2015.6825C12.085%2015.6825%2012.1675%2015.7157%2012.2345%2015.7753C12.3015%2015.8348%2012.3467%2015.9156%2012.3751%2015.9999C12.4029%2016.0832%2012.4293%2016.1666%2012.4552%2016.2499C12.8182%2017.4165%2013.0001%2018.5832%2013.0001%2019.7499C13.0001%2020.0832%2012.8664%2020.4166%2012.5997%2020.7499C12.5331%2020.8331%2012.4584%2020.9166%2012.3751%2020.9999C12.3125%2021.0613%2012.2509%2021.1205%2012.1886%2021.1639C12.1261%2021.2072%2012.0642%2021.2313%2012.0001%2021.2313C11.9361%2021.2313%2011.8742%2021.2072%2011.8116%2021.1639C11.7494%2021.1205%2011.6878%2021.0613%2011.6251%2020.9999C11.5419%2020.9166%2011.4671%2020.8331%2011.4005%2020.7499C11.1339%2020.4165%2011.0001%2020.0832%2011.0001%2019.7499C11.0001%2018.5832%2011.1821%2017.4165%2011.545%2016.2499C11.571%2016.1666%2011.5974%2016.0831%2011.6251%2015.9999C11.6536%2015.9157%2011.6987%2015.8348%2011.7657%2015.7753C11.8327%2015.7157%2011.9152%2015.6825%2012.0001%2015.6825ZM4.25501%2010.995C5.42165%2010.995%206.58836%2011.177%207.75501%2011.5399C7.83827%2011.5658%207.92174%2011.5922%208.00501%2011.62C8.08923%2011.6484%208.17006%2011.6936%208.22962%2011.7606C8.28914%2011.8276%208.32239%2011.9101%208.32239%2011.995C8.32237%2012.0799%208.28916%2012.1624%208.22962%2012.2294C8.17005%2012.2964%208.08924%2012.3416%208.00501%2012.37C7.92173%2012.3978%207.83828%2012.4242%207.75501%2012.4501C6.58836%2012.813%205.42165%2012.995%204.25501%2012.995C3.92169%2012.995%203.58832%2012.8612%203.25501%2012.5946C3.17176%2012.528%203.08826%2012.4532%203.00501%2012.37C2.94356%2012.3074%202.8844%2012.2457%202.84094%2012.1835C2.79764%2012.1209%202.77358%2012.059%202.77356%2011.995C2.77356%2011.9309%202.79763%2011.8691%202.84094%2011.8065C2.88441%2011.7442%202.94354%2011.6826%203.00501%2011.62C3.08828%2011.5367%203.17174%2011.462%203.25501%2011.3954C3.58834%2011.1287%203.92168%2010.995%204.25501%2010.995ZM19.755%2010.995C20.0883%2010.995%2020.4217%2011.1287%2020.755%2011.3954C20.8383%2011.462%2020.9218%2011.5367%2021.005%2011.62C21.0665%2011.6826%2021.1256%2011.7443%2021.1691%2011.8065C21.2124%2011.869%2021.2365%2011.931%2021.2365%2011.995C21.2364%2012.059%2021.2124%2012.1209%2021.1691%2012.1835C21.1256%2012.2457%2021.0665%2012.3074%2021.005%2012.37C20.9217%2012.4533%2020.8383%2012.528%2020.755%2012.5946C20.4217%2012.8613%2020.0883%2012.995%2019.755%2012.995C18.5884%2012.995%2017.4216%2012.813%2016.255%2012.4501C16.1717%2012.4242%2016.0883%2012.3977%2016.005%2012.37C15.9208%2012.3416%2015.84%2012.2964%2015.7804%2012.2294C15.7208%2012.1624%2015.6876%2012.0799%2015.6876%2011.995C15.6876%2011.9101%2015.7208%2011.8276%2015.7804%2011.7606C15.84%2011.6936%2015.9208%2011.6484%2016.005%2011.62C16.0883%2011.5922%2016.1717%2011.5658%2016.255%2011.5399C17.4217%2011.177%2018.5884%2010.995%2019.755%2010.995ZM3.01184%202.71179C3.09401%202.70274%203.18121%202.71636%203.26575%202.73523C3.41876%202.77056%203.5659%202.81217%203.70715%202.85925C4.27268%203.04778%204.74416%203.32991%205.12122%203.70691C6.44101%205.0267%207.63224%206.47524%208.69544%208.05163C8.77135%208.16419%208.84739%208.27761%208.922%208.39148C8.97197%208.46809%209.00252%208.55924%208.99915%208.65222C8.99566%208.74517%208.95911%208.8319%208.89563%208.89538C8.83214%208.95887%208.74542%208.99541%208.65247%208.9989C8.55948%209.00228%208.46834%208.97173%208.39172%208.92175C8.27786%208.84715%208.16444%208.7711%208.05188%208.69519C6.47549%207.63199%205.02695%206.44076%203.70715%205.12097C3.33016%204.74391%203.04803%204.27243%202.8595%203.70691C2.81239%203.56559%202.76984%203.41859%202.7345%203.2655C2.71563%203.18097%202.70298%203.09377%202.71204%203.0116C2.72122%202.92955%202.75295%202.85838%202.80579%202.80554C2.85864%202.7527%202.92979%202.72096%203.01184%202.71179ZM20.4738%202.71179C20.5558%202.72098%2020.627%202.75272%2020.6798%202.80554C20.7326%202.85838%2020.7644%202.92957%2020.7736%203.0116C20.7826%203.09377%2020.769%203.18097%2020.7501%203.2655C20.7148%203.41851%2020.6732%203.56566%2020.6261%203.70691C20.4376%204.2724%2020.1554%204.74392%2019.7784%205.12097C18.4587%206.44074%2017.0101%207.63201%2015.4337%208.69519C15.3212%208.77108%2015.2077%208.84716%2015.0939%208.92175C15.0172%208.9718%2014.9253%209.00238%2014.8322%208.9989C14.7394%208.9953%2014.6533%208.95873%2014.59%208.89538C14.5265%208.8319%2014.4899%208.74517%2014.4865%208.65222C14.4831%208.55924%2014.5136%208.46809%2014.5636%208.39148C14.6382%208.27763%2014.7143%208.16417%2014.7902%208.05163C15.8533%206.47527%2017.0446%205.02668%2018.3644%203.70691C18.7414%203.32994%2019.213%203.04777%2019.7784%202.85925C19.9197%202.81217%2020.0668%202.77055%2020.2198%202.73523C20.3044%202.71636%2020.3916%202.70274%2020.4738%202.71179ZM12.0001%202.76843C12.0642%202.76845%2012.1261%202.79251%2012.1886%202.83581C12.2509%202.87928%2012.3125%202.93841%2012.3751%202.99988C12.4584%203.08314%2012.5331%203.16661%2012.5997%203.24988C12.8664%203.58319%2013.0001%203.91656%2013.0001%204.24988C13.0001%205.41652%2012.8181%206.58323%2012.4552%207.74988C12.4293%207.83314%2012.4029%207.91661%2012.3751%207.99988C12.3467%208.0841%2012.3015%208.16492%2012.2345%208.22449C12.1675%208.28403%2012.085%208.31724%2012.0001%208.31726C11.9152%208.31726%2011.8327%208.28405%2011.7657%208.22449C11.6987%208.16491%2011.6536%208.08413%2011.6251%207.99988C11.5974%207.9166%2011.571%207.83315%2011.545%207.74988C11.1821%206.58322%2011.0001%205.41653%2011.0001%204.24988C11.0001%203.91656%2011.1339%203.58319%2011.4005%203.24988C11.4671%203.16663%2011.5419%203.08312%2011.6251%202.99988C11.6877%202.93843%2011.7494%202.87926%2011.8116%202.83581C11.8742%202.79253%2011.9361%202.76843%2012.0001%202.76843Z'%20fill='currentColor'/%3e%3c/g%3e%3c/svg%3e", Je = "data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20overflow='visible'%20style='display:%20block;'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='HarmonyOS%20Icon'%3e%3cpath%20id='Union'%20d='M12%2015.6738C12.0871%2015.6738%2012.1717%2015.7083%2012.2393%2015.7695C12.3067%2015.8307%2012.3507%2015.9135%2012.375%2016C12.4028%2016.0999%2012.4292%2016.1999%2012.4551%2016.2998C12.818%2017.6998%2013%2019.1%2013%2020.5C13%2020.9%2012.8663%2021.3002%2012.5996%2021.7002C12.533%2021.8001%2012.4582%2021.9001%2012.375%2022C12.3188%2022.0663%2012.2614%2022.1299%2012.1982%2022.1768C12.1349%2022.2236%2012.0686%2022.25%2012%2022.25C11.9314%2022.25%2011.8651%2022.2236%2011.8018%2022.1768C11.7386%2022.1299%2011.6812%2022.0663%2011.625%2022C11.5418%2021.9001%2011.467%2021.8001%2011.4004%2021.7002C11.1337%2021.3002%2011%2020.9%2011%2020.5C11%2019.1%2011.182%2017.6998%2011.5449%2016.2998C11.5708%2016.1999%2011.5972%2016.0999%2011.625%2016C11.6493%2015.9135%2011.6933%2015.8307%2011.7607%2015.7695C11.8283%2015.7083%2011.9129%2015.6738%2012%2015.6738ZM9.16699%2014.4932C9.258%2014.4976%209.34178%2014.5332%209.40332%2014.5947C9.46485%2014.6563%209.50039%2014.7401%209.50488%2014.8311C9.50929%2014.9219%209.48235%2015.0116%209.43848%2015.0898C9.38753%2015.18%209.33545%2015.2696%209.2832%2015.3584C8.54993%2016.605%207.68816%2017.7239%206.69824%2018.7139C6.4154%2018.9967%206.03781%2019.185%205.56641%2019.2793C5.44867%2019.3028%205.3248%2019.3212%205.19531%2019.333C5.10879%2019.3401%205.02298%2019.3445%204.94531%2019.333C4.8676%2019.3213%204.80235%2019.2926%204.75391%2019.2441C4.70547%2019.1957%204.67673%2019.1305%204.66504%2019.0527C4.65357%2018.975%204.65794%2018.8893%204.66504%2018.8027C4.67681%2018.6732%204.69522%2018.5494%204.71875%2018.4316C4.81303%2017.9603%205.00135%2017.5826%205.28418%2017.2998C6.27411%2016.3099%207.39308%2015.4481%208.63965%2014.7148C8.72849%2014.6626%208.81806%2014.6105%208.9082%2014.5596C8.98647%2014.5157%209.07612%2014.4888%209.16699%2014.4932ZM14.8428%2014.4932C14.9336%2014.4888%2015.0233%2014.5157%2015.1016%2014.5596C15.1918%2014.6106%2015.2821%2014.6625%2015.3711%2014.7148C16.6175%2015.4481%2017.7357%2016.31%2018.7256%2017.2998C19.0084%2017.5826%2019.1967%2017.9602%2019.291%2018.4316C19.3145%2018.5494%2019.333%2018.6732%2019.3447%2018.8027C19.3518%2018.8892%2019.3562%2018.9751%2019.3447%2019.0527C19.333%2019.1304%2019.3043%2019.1957%2019.2559%2019.2441C19.2074%2019.2925%2019.1422%2019.3213%2019.0645%2019.333C18.9867%2019.3445%2018.9011%2019.3401%2018.8145%2019.333C18.685%2019.3212%2018.5611%2019.3028%2018.4434%2019.2793C17.972%2019.185%2017.5943%2018.9967%2017.3115%2018.7139C16.3216%2017.724%2015.4608%2016.6049%2014.7275%2015.3584C14.6752%2015.2694%2014.6223%2015.1801%2014.5713%2015.0898C14.5274%2015.0116%2014.5005%2014.9219%2014.5049%2014.8311C14.5093%2014.74%2014.5449%2014.6553%2014.6064%2014.5938C14.6679%2014.5325%2014.752%2014.4977%2014.8428%2014.4932ZM3.5%2011C4.9%2011%206.3002%2011.182%207.7002%2011.5449C7.8001%2011.5708%207.9001%2011.5972%208%2011.625C8.08648%2011.6493%208.16926%2011.6933%208.23047%2011.7607C8.2917%2011.8283%208.32617%2011.9129%208.32617%2012C8.32617%2012.0871%208.2917%2012.1717%208.23047%2012.2393C8.16926%2012.3067%208.08648%2012.3507%208%2012.375C7.9001%2012.4028%207.8001%2012.4292%207.7002%2012.4551C6.3002%2012.818%204.9%2013%203.5%2013C3.1%2013%202.6998%2012.8663%202.2998%2012.5996C2.19991%2012.533%202.09989%2012.4582%202%2012.375C1.9337%2012.3188%201.87013%2012.2614%201.82324%2012.1982C1.77644%2012.1349%201.75%2012.0686%201.75%2012C1.75%2011.9314%201.77644%2011.8651%201.82324%2011.8018C1.87013%2011.7386%201.9337%2011.6812%202%2011.625C2.09989%2011.5418%202.19991%2011.467%202.2998%2011.4004C2.6998%2011.1337%203.1%2011%203.5%2011ZM20.5%2011C20.9%2011%2021.3002%2011.1337%2021.7002%2011.4004C21.8001%2011.467%2021.9001%2011.5418%2022%2011.625C22.0663%2011.6812%2022.1299%2011.7386%2022.1768%2011.8018C22.2236%2011.8651%2022.25%2011.9314%2022.25%2012C22.25%2012.0686%2022.2236%2012.1349%2022.1768%2012.1982C22.1299%2012.2614%2022.0663%2012.3188%2022%2012.375C21.9001%2012.4582%2021.8001%2012.533%2021.7002%2012.5996C21.3002%2012.8663%2020.9%2013%2020.5%2013C19.1%2013%2017.6998%2012.818%2016.2998%2012.4551C16.1999%2012.4292%2016.0999%2012.4028%2016%2012.375C15.9135%2012.3507%2015.8307%2012.3067%2015.7695%2012.2393C15.7083%2012.1717%2015.6738%2012.0871%2015.6738%2012C15.6738%2011.9129%2015.7083%2011.8283%2015.7695%2011.7607C15.8307%2011.6933%2015.9135%2011.6493%2016%2011.625C16.0999%2011.5972%2016.1999%2011.5708%2016.2998%2011.5449C17.6998%2011.182%2019.1%2011%2020.5%2011ZM5.20215%204.66016C5.33165%204.67193%205.4555%204.69033%205.57324%204.71387C6.04458%204.80816%206.42227%204.99648%206.70508%205.2793C7.69489%206.26915%208.55682%207.38735%209.29004%208.63379C9.34236%208.72275%209.39429%208.81306%209.44531%208.90332C9.48913%208.98154%209.51612%209.07132%209.51172%209.16211C9.5072%209.25304%209.47165%209.33695%209.41016%209.39844C9.34865%209.45992%209.26478%209.4955%209.17383%209.5C9.08302%209.50441%208.99326%209.47742%208.91504%209.43359C8.82481%209.3826%208.7354%209.32965%208.64648%209.27734C7.39998%208.54411%206.28091%207.68321%205.29102%206.69336C5.00822%206.41056%204.81988%206.03282%204.72559%205.56152C4.70205%205.44378%204.68365%205.31993%204.67188%205.19043C4.66476%205.10382%204.6604%205.01817%204.67188%204.94043C4.68356%204.86264%204.71228%204.79751%204.76074%204.74902C4.80921%204.70056%204.87438%204.67185%204.95215%204.66016C5.02987%204.64869%205.11557%204.65305%205.20215%204.66016ZM19.0576%204.66016C19.1354%204.67185%2019.2006%204.70056%2019.249%204.74902C19.2975%204.7975%2019.3262%204.86265%2019.3379%204.94043C19.3494%205.01815%2019.345%205.10385%2019.3379%205.19043C19.3261%205.31993%2019.3077%205.44378%2019.2842%205.56152C19.1899%206.03285%2019.0016%206.41055%2018.7188%206.69336C17.7289%207.68322%2016.6098%208.54507%2015.3633%209.27832C15.2745%209.33054%2015.1848%209.38267%2015.0947%209.43359C15.0165%209.47743%2014.9268%209.50441%2014.8359%209.5C14.745%209.4955%2014.6611%209.45994%2014.5996%209.39844C14.5381%209.33693%2014.5026%209.25307%2014.498%209.16211C14.4936%209.0713%2014.5206%208.98155%2014.5645%208.90332C14.6154%208.81323%2014.6675%208.72355%2014.7197%208.63477C15.453%207.38825%2016.3148%206.2692%2017.3047%205.2793C17.5875%204.99648%2017.9652%204.80816%2018.4365%204.71387C18.5543%204.69033%2018.6781%204.67193%2018.8076%204.66016C18.8942%204.65305%2018.9799%204.64869%2019.0576%204.66016ZM12%201.75C12.0686%201.75%2012.1349%201.77644%2012.1982%201.82324C12.2614%201.87013%2012.3188%201.9337%2012.375%202C12.4582%202.09989%2012.533%202.19991%2012.5996%202.2998C12.8663%202.6998%2013%203.1%2013%203.5C13%204.9%2012.818%206.3002%2012.4551%207.7002C12.4292%207.8001%2012.4028%207.9001%2012.375%208C12.3507%208.08648%2012.3067%208.16926%2012.2393%208.23047C12.1717%208.2917%2012.0871%208.32617%2012%208.32617C11.9129%208.32617%2011.8283%208.2917%2011.7607%208.23047C11.6933%208.16926%2011.6493%208.08648%2011.625%208C11.5972%207.9001%2011.5708%207.8001%2011.5449%207.7002C11.182%206.3002%2011%204.9%2011%203.5C11%203.1%2011.1337%202.6998%2011.4004%202.2998C11.467%202.19991%2011.5418%202.09989%2011.625%202C11.6812%201.9337%2011.7386%201.87013%2011.8018%201.82324C11.8651%201.77644%2011.9314%201.75%2012%201.75Z'%20fill='currentColor'/%3e%3c/g%3e%3c/svg%3e", et = "data:image/svg+xml,%3csvg%20preserveAspectRatio='none'%20overflow='visible'%20style='display:%20block;'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='HarmonyOS%20Icon'%3e%3cpath%20id='Union'%20d='M12.2031%2017.9033C12.2849%2017.9033%2012.3645%2017.9351%2012.4307%2017.9922C12.4969%2018.0494%2012.544%2018.1271%2012.5781%2018.208C12.6059%2018.2747%2012.6323%2018.3415%2012.6582%2018.4082C13.0212%2019.3415%2013.2031%2020.2747%2013.2031%2021.208C13.2031%2021.4747%2013.0694%2021.7411%2012.8027%2022.0078C12.7361%2022.0744%2012.6614%2022.1414%2012.5781%2022.208C12.5078%2022.2631%2012.4403%2022.3155%2012.3789%2022.3545C12.3169%2022.3934%2012.2612%2022.416%2012.2031%2022.416C12.145%2022.416%2012.0893%2022.3934%2012.0273%2022.3545C11.9659%2022.3155%2011.8984%2022.2631%2011.8281%2022.208C11.7448%2022.1414%2011.6702%2022.0744%2011.6035%2022.0078C11.3368%2021.7411%2011.2031%2021.4747%2011.2031%2021.208C11.2031%2020.2747%2011.3851%2019.3415%2011.748%2018.4082C11.774%2018.3415%2011.8003%2018.2747%2011.8281%2018.208C11.8623%2018.1271%2011.9093%2018.0494%2011.9756%2017.9922C12.0418%2017.9351%2012.1213%2017.9033%2012.2031%2017.9033ZM7.9541%2016.1338C8.04109%2016.1403%208.12001%2016.1737%208.17773%2016.2314C8.23545%2016.2892%208.26887%2016.3681%208.27539%2016.4551C8.2818%2016.5422%208.26044%2016.6307%208.22754%2016.7119C8.20011%2016.7785%208.17131%2016.8449%208.14258%2016.9102C7.73931%2017.8267%207.20772%2018.6155%206.54785%2019.2754C6.35932%2019.4639%206.07625%2019.5576%205.69922%2019.5576C5.60498%2019.5576%205.50445%2019.5528%205.39844%2019.541C5.30991%2019.5303%205.22519%2019.5197%205.1543%2019.5039C5.08294%2019.4876%205.02741%2019.4639%204.98633%2019.4229C4.94525%2019.3818%204.92156%2019.3263%204.90527%2019.2549C4.88945%2019.184%204.87886%2019.0993%204.86816%2019.0107C4.85638%2018.9047%204.85059%2018.8042%204.85059%2018.71C4.85061%2018.3329%204.94525%2018.0499%205.13379%2017.8613C5.79371%2017.2015%206.5825%2016.6699%207.49902%2016.2666C7.56424%2016.2379%207.62977%2016.209%207.69629%2016.1816C7.77762%2016.1486%207.86681%2016.1274%207.9541%2016.1338ZM16.4629%2016.1338C16.5501%2016.1274%2016.6385%2016.1486%2016.7197%2016.1816C16.7865%2016.2091%2016.8525%2016.2378%2016.918%2016.2666C17.8345%2016.6699%2018.6233%2017.2014%2019.2832%2017.8613C19.4716%2018.0499%2019.5654%2018.333%2019.5654%2018.71C19.5654%2018.8042%2019.5596%2018.9047%2019.5479%2019.0107C19.5372%2019.0993%2019.5266%2019.184%2019.5107%2019.2549C19.4945%2019.3262%2019.4708%2019.3818%2019.4297%2019.4229C19.3886%2019.4638%2019.333%2019.4867%2019.2617%2019.5029C19.1908%2019.5188%2019.1062%2019.5303%2019.0176%2019.541C18.9116%2019.5528%2018.811%2019.5576%2018.7168%2019.5576C18.3399%2019.5575%2018.0567%2019.4639%2017.8682%2019.2754C17.2083%2018.6155%2016.6777%2017.8266%2016.2744%2016.9102C16.2456%2016.8447%2016.2169%2016.7786%2016.1895%2016.7119C16.1565%2016.6306%2016.1342%2016.5423%2016.1406%2016.4551C16.1471%2016.368%2016.1815%2016.2892%2016.2393%2016.2314C16.2971%2016.1738%2016.3759%2016.1402%2016.4629%2016.1338ZM3.20801%2011.2031C4.14134%2011.2031%205.07448%2011.3851%206.00781%2011.748C6.07447%2011.774%206.14136%2011.8004%206.20801%2011.8281C6.28886%2011.8623%206.36665%2011.9093%206.42383%2011.9756C6.48088%2012.0418%206.5127%2012.1214%206.5127%2012.2031C6.51266%2012.2849%206.48089%2012.3645%206.42383%2012.4307C6.36665%2012.4969%206.28885%2012.544%206.20801%2012.5781C6.14136%2012.6059%206.07446%2012.6323%206.00781%2012.6582C5.0745%2013.0212%204.14132%2013.2031%203.20801%2013.2031C2.94136%2013.2031%202.67485%2013.0694%202.4082%2012.8027C2.34159%2012.7361%202.27462%2012.6614%202.20801%2012.5781C2.15291%2012.5079%202.1005%2012.4403%202.06152%2012.3789C2.0226%2012.317%202.00003%2012.2612%202%2012.2031C2%2012.1451%202.02261%2012.0893%202.06152%2012.0273C2.10049%2011.966%202.15291%2011.8984%202.20801%2011.8281C2.27462%2011.7449%202.34159%2011.6701%202.4082%2011.6035C2.67487%2011.3368%202.94134%2011.2031%203.20801%2011.2031ZM21.208%2011.2031C21.4747%2011.2031%2021.7411%2011.3368%2022.0078%2011.6035C22.0744%2011.6701%2022.1414%2011.7449%2022.208%2011.8281C22.2631%2011.8984%2022.3155%2011.966%2022.3545%2012.0273C22.3934%2012.0893%2022.416%2012.1451%2022.416%2012.2031C22.416%2012.2612%2022.3934%2012.317%2022.3545%2012.3789C22.3155%2012.4403%2022.2631%2012.5079%2022.208%2012.5781C22.1414%2012.6614%2022.0744%2012.7361%2022.0078%2012.8027C21.7412%2013.0694%2021.4747%2013.2031%2021.208%2013.2031C20.2747%2013.2031%2019.3415%2013.0212%2018.4082%2012.6582C18.3416%2012.6323%2018.2747%2012.6059%2018.208%2012.5781C18.1272%2012.544%2018.0494%2012.4969%2017.9922%2012.4307C17.9351%2012.3645%2017.9034%2012.2849%2017.9033%2012.2031C17.9033%2012.1214%2017.9351%2012.0418%2017.9922%2011.9756C18.0494%2011.9093%2018.1272%2011.8623%2018.208%2011.8281C18.2747%2011.8004%2018.3416%2011.774%2018.4082%2011.748C19.3415%2011.3851%2020.2747%2011.2031%2021.208%2011.2031ZM5.70605%204.85059C6.08313%204.8506%206.36614%204.94524%206.55469%205.13379C7.21449%205.79365%207.74616%206.58164%208.14941%207.49805C8.17819%207.56345%208.2069%207.62958%208.23438%207.69629C8.26736%207.77749%208.28854%207.86597%208.28223%207.95312C8.27579%208.04031%208.2424%208.11991%208.18457%208.17773C8.12683%208.23543%208.04793%208.26888%207.96094%208.27539C7.87372%208.28181%207.78538%208.25955%207.7041%208.22656C7.63736%208.19908%207.57129%208.17039%207.50586%208.1416C6.58934%207.73833%205.80055%207.20772%205.14062%206.54785C4.9521%206.35933%204.85844%206.07622%204.8584%205.69922C4.8584%205.60498%204.86322%205.50445%204.875%205.39844C4.8857%205.30991%204.89629%205.22519%204.91211%205.1543C4.92839%205.08297%204.95213%205.0274%204.99316%204.98633C5.03424%204.94525%205.08977%204.92156%205.16113%204.90527C5.23202%204.88945%205.31673%204.87886%205.40527%204.86816C5.51129%204.85638%205.61181%204.85059%205.70605%204.85059ZM18.71%204.85059C18.8042%204.85059%2018.9047%204.85638%2019.0107%204.86816C19.0993%204.87886%2019.184%204.88945%2019.2549%204.90527C19.3263%204.92156%2019.3818%204.94525%2019.4229%204.98633C19.4639%205.0274%2019.4876%205.08296%2019.5039%205.1543C19.5197%205.22519%2019.5303%205.30991%2019.541%205.39844C19.5528%205.50445%2019.5576%205.60498%2019.5576%205.69922C19.5576%206.07625%2019.4639%206.35932%2019.2754%206.54785C18.6155%207.20773%2017.8267%207.7393%2016.9102%208.14258C16.8448%208.17132%2016.7785%208.20011%2016.7119%208.22754C16.6307%208.26046%2016.5422%208.2818%2016.4551%208.27539C16.3681%208.26888%2016.2892%208.23545%2016.2314%208.17773C16.1737%208.12001%2016.1403%208.04109%2016.1338%207.9541C16.1274%207.86681%2016.1486%207.77762%2016.1816%207.69629C16.209%207.62977%2016.2379%207.56424%2016.2666%207.49902C16.6699%206.58249%2017.2014%205.79372%2017.8613%205.13379C18.0499%204.94524%2018.3329%204.8506%2018.71%204.85059ZM12.2031%202C12.2612%202%2012.3169%202.02258%2012.3789%202.06152C12.4403%202.1005%2012.5078%202.15288%2012.5781%202.20801C12.6614%202.27464%2012.7361%202.34157%2012.8027%202.4082C13.0694%202.67487%2013.2031%202.94134%2013.2031%203.20801C13.2031%204.14134%2013.0212%205.07448%2012.6582%206.00781C12.6323%206.07448%2012.6059%206.14134%2012.5781%206.20801C12.544%206.28888%2012.4969%206.36664%2012.4307%206.42383C12.3645%206.48092%2012.2849%206.5127%2012.2031%206.5127C12.1213%206.5127%2012.0418%206.48092%2011.9756%206.42383C11.9093%206.36664%2011.8623%206.28888%2011.8281%206.20801C11.8003%206.14134%2011.774%206.07448%2011.748%206.00781C11.3851%205.07448%2011.2031%204.14134%2011.2031%203.20801C11.2031%202.94134%2011.3368%202.67487%2011.6035%202.4082C11.6702%202.34157%2011.7448%202.27464%2011.8281%202.20801C11.8984%202.15288%2011.9659%202.1005%2012.0273%202.06152C12.0893%202.02258%2012.145%202%2012.2031%202Z'%20fill='currentColor'/%3e%3c/g%3e%3c/svg%3e", tt = "_icon_wrtjh_2", nt = {
  icon: tt
}, ot = [
  "arrow-down",
  "unselected",
  "chevron-left",
  "selected",
  "delete",
  "waitlist-message",
  "creative",
  "ultimate",
  "standard",
  "minimal",
  "arrow-left",
  "arrow-right",
  "arrow-up",
  "arrow-up-right",
  "bell",
  "browser",
  "check-circle",
  "check-fill",
  "check-line",
  "chevron-down",
  "chevron-right",
  "chevron-up",
  "circle",
  "clock",
  "command-mac",
  "commit",
  "device-mac",
  "download",
  "duplicate",
  "edit",
  "extension",
  "eye",
  "files",
  "filter",
  "floating-window",
  "folder",
  "gear",
  "git",
  "image",
  "info",
  "level",
  "link",
  "mic",
  "mini-app",
  "more",
  "palette",
  "pin",
  "plus",
  "progress-25",
  "refresh",
  "search",
  "session",
  "settings",
  "show-session",
  "side-chat",
  "sidebar-left",
  "sidebar-right",
  "spark",
  "star",
  "store",
  "terminal",
  "thinking",
  "turn",
  "upload",
  "user",
  "xmark"
], rt = { download: "arrow-down", circle: "unselected" }, Ot = ot.filter((t) => t !== "turn" && !(t in rt)).sort(), at = {
  creative: Ye,
  ultimate: Qe,
  standard: Je,
  minimal: et,
  git: Xe
}, S2 = {
  "arrow-down": A2,
  unselected: m2,
  "chevron-left": J0,
  selected: y2,
  delete: Ne,
  "waitlist-message": j1,
  "arrow-left": I0,
  "arrow-right": q0,
  "arrow-up": Z0,
  "arrow-up-right": P0,
  bell: B0,
  browser: x1,
  "check-circle": y2,
  "check-fill": y2,
  "check-line": G0,
  "chevron-down": Y0,
  "chevron-right": t1,
  "chevron-up": o1,
  circle: m2,
  clock: c1,
  "command-mac": d1,
  commit: _1,
  "device-mac": R1,
  download: A2,
  duplicate: f1,
  edit: ee,
  extension: se,
  eye: y1,
  files: v1,
  filter: S1,
  "floating-window": S0,
  folder: w1,
  gear: fe,
  image: N1,
  info: L1,
  level: ye,
  link: D1,
  mic: F1,
  "mini-app": U0,
  more: h1,
  palette: K1,
  pin: ne,
  plus: re,
  "progress-25": z1,
  refresh: ce,
  search: de,
  session: O1,
  settings: he,
  "show-session": V1,
  "side-chat": H1,
  "sidebar-left": X1,
  "sidebar-right": Q1,
  spark: ve,
  star: we,
  store: _e,
  terminal: xe,
  thinking: W0,
  turn: m2,
  upload: $e,
  user: Ae,
  xmark: Te
}, st = 1.6, it = D(function({
  className: e,
  glyph: n,
  label: o,
  name: s,
  size: a = "lg",
  style: l,
  tone: u = "inherit",
  ...i
}, C) {
  const y = s ? at[s] : void 0, w = y ? `url("${y}")` : void 0, m = n ?? (s && s in S2 ? S2[s] : void 0), b = w ? {
    ...l,
    WebkitMaskImage: w,
    maskImage: w
  } : l ?? {};
  return /* @__PURE__ */ f(
    "span",
    {
      ...i,
      "aria-hidden": o ? void 0 : "true",
      "aria-label": o,
      className: L(nt.icon, e),
      "data-openbitfun-component": "icon",
      "data-openbitfun-name": s,
      "data-openbitfun-source": y ? "catalog" : "line",
      "data-openbitfun-artwork": s && s !== "progress-25" && s !== "turn" ? "monochrome" : void 0,
      "data-openbitfun-tone": u,
      "data-size": a,
      ref: C,
      role: o ? "img" : void 0,
      style: b,
      children: m ? /* @__PURE__ */ f(
        m,
        {
          "aria-hidden": "true",
          focusable: "false",
          strokeWidth: st
        }
      ) : null
    }
  );
});
class ct {
  layers = [];
  listeners = /* @__PURE__ */ new Set();
  version = 0;
  register(e) {
    return this.layers = [
      ...this.layers.filter((n) => n.id !== e.id),
      e
    ], this.notify(), () => {
      const n = this.layers.filter((o) => o.id !== e.id);
      n.length !== this.layers.length && (this.layers = n, this.notify());
    };
  }
  isTopLayer(e) {
    return this.layers[this.layers.length - 1]?.id === e;
  }
  dismissTop(e) {
    const n = this.findTopIndex(e), o = n >= 0 ? this.layers[n] : void 0;
    return o ? (o.onDismiss("programmatic"), !0) : !1;
  }
  dismissAll() {
    return this.layers.length === 0 ? !1 : ([...this.layers].reverse().forEach((e) => {
      e.onDismiss("programmatic");
    }), !0);
  }
  hasLayers(e) {
    return this.findTopIndex(e) >= 0;
  }
  subscribe = (e) => (this.listeners.add(e), () => this.listeners.delete(e));
  getSnapshot = () => this.version;
  findTopIndex(e) {
    if (!e) return this.layers.length - 1;
    for (let n = this.layers.length - 1; n >= 0; n -= 1)
      if (this.layers[n]?.scope === e) return n;
    return -1;
  }
  notify() {
    this.version += 1, this.listeners.forEach((e) => e());
  }
}
const lt = new ct();
function x2() {
  return l2(a0) ?? lt;
}
function qt(t) {
  const e = x2();
  return Y2(e.subscribe, e.getSnapshot, e.getSnapshot), e.hasLayers(t);
}
function Ht() {
  const t = x2(), e = q(
    (o) => t.dismissTop(o),
    [t]
  );
  return { dismissAll: q(() => t.dismissAll(), [t]), dismissTop: e };
}
function T2(t) {
  return !!(t && typeof t.nodeType == "number");
}
function dt({
  branchRefs: t = [],
  containsTarget: e,
  dismissOnEscape: n = !0,
  dismissOnPointerOutside: o = !0,
  enabled: s,
  layerRef: a,
  onDismiss: l,
  ownerDocument: u,
  scope: i
}) {
  const C = x2(), y = E(/* @__PURE__ */ Symbol("openbitfun-overlay-layer")), w = E(l);
  return w.current = l, $(() => {
    if (s)
      return C.register({
        id: y.current,
        onDismiss: (m) => w.current(m),
        scope: i
      });
  }, [s, i, C]), $(() => {
    if (!s) return;
    const m = u ?? a.current?.ownerDocument ?? (typeof document > "u" ? null : document);
    if (!m) return;
    const b = (h) => {
      h.key !== "Escape" || B2(h) || !n || !C.isTopLayer(y.current) || (h.preventDefault(), h.stopPropagation(), w.current("escape-key"));
    }, v = (h) => {
      if (!o || !C.isTopLayer(y.current) || !T2(h.target))
        return;
      const g = h.target;
      T2(g) && (a.current?.contains(g) || t.some((A) => A.current?.contains(g)) || e?.(g) || w.current("pointer-outside"));
    };
    return m.addEventListener("keydown", b, !0), m.addEventListener("pointerdown", v, !0), () => {
      m.removeEventListener("keydown", b, !0), m.removeEventListener("pointerdown", v, !0);
    };
  }, [t, e, n, o, s, a, u, C]), y.current;
}
const ut = typeof window > "u" ? $ : b2, ft = [
  "button:not([disabled])",
  "[href]",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])'
].join(",");
function z2(t) {
  return Array.from(t.querySelectorAll(ft)).filter((e) => e.getAttribute("aria-hidden") !== "true");
}
function Ct({
  active: t,
  autoFocus: e = !0,
  containerRef: n,
  initialFocusRef: o,
  ownerDocument: s,
  restoreFocus: a = !0,
  trapFocus: l = !0
}) {
  ut(() => {
    if (!t) return;
    const u = n.current, i = s ?? u?.ownerDocument ?? (typeof document > "u" ? null : document);
    if (!u || !i) return;
    const C = i.defaultView?.HTMLElement, y = C && i.activeElement instanceof C ? i.activeElement : null;
    e && (o?.current ?? z2(u)[0] ?? u).focus();
    const w = (m) => {
      if (!l || m.key !== "Tab") return;
      const b = z2(u);
      if (b.length === 0) {
        m.preventDefault(), u.focus();
        return;
      }
      const v = b[0], h = b[b.length - 1];
      m.shiftKey && i.activeElement === v ? (m.preventDefault(), h?.focus()) : !m.shiftKey && i.activeElement === h && (m.preventDefault(), v?.focus());
    };
    return i.addEventListener("keydown", w, !0), () => {
      i.removeEventListener("keydown", w, !0), a && y?.isConnected && y.focus();
    };
  }, [t, e, n, o, s, a, l]);
}
function ht(t, e) {
  const [n, o] = e2(t), [s, a] = e2(t ? "entered" : "exiting");
  return $(() => {
    if (t) {
      o(!0), a("entering");
      const i = typeof window > "u" ? null : window;
      if (!i) {
        a("entered");
        return;
      }
      let C = 0, y = 0;
      return C = i.requestAnimationFrame(() => {
        y = i.requestAnimationFrame(() => a("entered"));
      }), () => {
        i.cancelAnimationFrame(C), i.cancelAnimationFrame(y);
      };
    }
    if (!n) return;
    a("exiting");
    const l = typeof window > "u" ? null : window;
    if (!l) {
      o(!1);
      return;
    }
    const u = l.setTimeout(() => o(!1), e);
    return () => l.clearTimeout(u);
  }, [e, t, n]), { present: n, state: s };
}
const i2 = /* @__PURE__ */ new WeakMap(), k2 = /* @__PURE__ */ new WeakMap();
function pt(t, e) {
  $(() => {
    if (!t) return;
    const n = e ?? (typeof document > "u" ? null : document);
    if (!n) return;
    const o = (i2.get(n) ?? 0) + 1;
    return o === 1 && (k2.set(n, n.body.style.overflow), n.body.style.overflow = "hidden"), i2.set(n, o), () => {
      const s = Math.max(0, (i2.get(n) ?? 1) - 1);
      s === 0 ? (n.body.style.overflow = k2.get(n) ?? "", k2.delete(n), i2.delete(n)) : i2.set(n, s);
    };
  }, [t, e]);
}
const yt = "_overlay_o9tzm_2", mt = "_surface_o9tzm_3", vt = "_header_o9tzm_4", kt = "_heading_o9tzm_5", wt = "_body_o9tzm_6", gt = "_footer_o9tzm_7", _t = "_title_o9tzm_93", bt = "_description_o9tzm_106", xt = "_headerActions_o9tzm_116", Mt = "_close_o9tzm_123", G = {
  overlay: yt,
  surface: mt,
  header: vt,
  heading: kt,
  body: wt,
  footer: gt,
  title: _t,
  description: bt,
  headerActions: xt,
  close: Mt
}, Nt = 180, F2 = c2(null);
function M2(t) {
  const e = l2(F2);
  if (!e) throw new Error(`${t} must be rendered inside Dialog or Sheet.`);
  return e;
}
function _2(t, e) {
  return O2.toArray(t).some((n) => {
    if (!J2(n)) return !1;
    if (n.type === e) return !0;
    const o = n.props.children;
    return o !== void 0 && _2(o, e);
  });
}
const U2 = D(function({
  "aria-describedby": e,
  "aria-label": n,
  "aria-labelledby": o,
  autoFocus: s = !0,
  restoreFocus: a = !0,
  portalTarget: l,
  overlayProps: u,
  children: i,
  className: C,
  closeOnEscape: y = !0,
  closeOnPointerOutside: w = !0,
  initialFocusRef: m,
  kind: b,
  onOpenChange: v,
  onExitComplete: h,
  open: g,
  placement: A,
  preventScroll: V = !0,
  role: R = "dialog",
  size: B,
  trapFocus: F = !0,
  ...p
}, H) {
  const T = C2(), k = P2(l ?? T.portalHost), z = k?.ownerDocument ?? (typeof document > "u" ? null : document), P = E(null), X = `openbitfun-dialog-title-${w2()}`, W = `openbitfun-dialog-description-${w2()}`, { present: d, state: N } = ht(g, Nt), M = E(null), _ = E(d);
  b2(() => {
    g ? M.current = i : d || (M.current = null);
  }, [i, g, d]), $(() => {
    const U = _.current && !d && !g;
    _.current = d, U && h?.();
  }, [h, g, d]);
  const S = g ? i : M.current, Q = _2(S, Et), I = _2(S, Lt), n2 = q((U) => {
    g && v(!1, U);
  }, [v, g]), h2 = Q2(() => ({
    close: n2,
    descriptionId: W,
    titleId: X
  }), [n2, W, X]), p2 = q((U) => {
    P.current = U, typeof H == "function" ? H(U) : H && (H.current = U);
  }, [H]);
  if (dt({
    dismissOnEscape: y,
    dismissOnPointerOutside: w,
    enabled: g,
    layerRef: P,
    onDismiss: (U) => n2(U === "escape-key" ? "escape-key" : "pointer-outside"),
    ownerDocument: z
  }), Ct({
    active: g,
    autoFocus: s,
    containerRef: P,
    initialFocusRef: m,
    ownerDocument: z,
    trapFocus: F,
    restoreFocus: a
  }), pt((g || d) && V, z), !d || !k) return null;
  const a2 = N === "exiting";
  return /* @__PURE__ */ f(j2, { target: k, children: /* @__PURE__ */ f(
    "div",
    {
      ...u,
      className: L(G.overlay, u?.className),
      "data-openbitfun-component": b,
      "data-openbitfun-part": "overlay",
      "data-openbitfun-native-webview-occlusion": !0,
      "data-placement": A,
      "data-state": a2 ? "exiting" : "open",
      children: /* @__PURE__ */ f(F2.Provider, { value: h2, children: /* @__PURE__ */ f(
        "div",
        {
          ...p,
          ...g ? {} : { inert: "" },
          "aria-describedby": e ?? (I ? W : void 0),
          "aria-hidden": a2 || void 0,
          "aria-label": n,
          "aria-labelledby": o ?? (!n && Q ? X : void 0),
          "aria-modal": "true",
          className: L(G.surface, C),
          "data-openbitfun-component": b,
          "data-openbitfun-part": "surface",
          "data-placement": A,
          "data-size": B,
          "data-state": a2 ? "exiting" : "open",
          ref: p2,
          role: R,
          tabIndex: -1,
          children: S
        }
      ) })
    }
  ) });
}), Pt = D(function({
  size: e = "md",
  ...n
}, o) {
  return /* @__PURE__ */ f(U2, { ...n, kind: "dialog", ref: o, size: e });
}), jt = D(function({
  placement: e = "right",
  size: n = "md",
  ...o
}, s) {
  return /* @__PURE__ */ f(
    U2,
    {
      ...o,
      kind: "sheet",
      placement: e,
      ref: s,
      size: n
    }
  );
}), Zt = D(
  function({ className: e, separator: n = !1, ...o }, s) {
    return /* @__PURE__ */ f("header", { ...o, className: L(G.header, e), "data-openbitfun-part": "header", "data-separator": n, ref: s });
  }
), Vt = D(
  function({ className: e, ...n }, o) {
    return /* @__PURE__ */ f("div", { ...n, className: L(G.heading, e), "data-openbitfun-part": "heading", ref: o });
  }
), Et = D(
  function({ children: e, className: n, id: o, ...s }, a) {
    const l = M2("DialogTitle");
    return /* @__PURE__ */ f("h2", { ...s, className: L(G.title, n), "data-openbitfun-part": "title", id: o ?? l.titleId, ref: a, children: /* @__PURE__ */ f(Z2, { children: e }) });
  }
), Lt = D(
  function({ className: e, id: n, ...o }, s) {
    const a = M2("DialogDescription");
    return /* @__PURE__ */ f("p", { ...o, className: L(G.description, e), "data-openbitfun-part": "description", id: n ?? a.descriptionId, ref: s });
  }
), Bt = D(
  function({ className: e, ...n }, o) {
    return /* @__PURE__ */ f("div", { ...n, className: L(G.headerActions, e), "data-openbitfun-part": "header-actions", ref: o });
  }
), Ft = D(
  function({ "aria-label": e, className: n, icon: o, ...s }, a) {
    const l = M2("DialogClose"), u = C2();
    return /* @__PURE__ */ f(
      Ge,
      {
        ...s,
        "aria-label": e ?? u.messages.dialogClose,
        className: L(G.close, n),
        "data-openbitfun-part": "close",
        icon: o ?? /* @__PURE__ */ f(it, { name: "xmark" }),
        onClick: () => l.close("close-button"),
        ref: a,
        size: "sm",
        variant: "quiet"
      }
    );
  }
), Ut = D(
  function({ className: e, inset: n = "standard", ...o }, s) {
    return /* @__PURE__ */ f(
      "div",
      {
        ...o,
        className: L(G.body, e),
        "data-openbitfun-part": "body",
        "data-inset": n,
        ref: s
      }
    );
  }
), Rt = D(
  function({ appearance: e = "attached", className: n, separator: o = !1, ...s }, a) {
    return /* @__PURE__ */ f(
      "footer",
      {
        ...s,
        className: L(G.footer, n),
        "data-appearance": e,
        "data-separator": o,
        "data-openbitfun-part": "footer",
        ref: a
      }
    );
  }
);
export {
  Lt as $,
  Z0 as A,
  zt as B,
  y2 as C,
  Pt as D,
  o0 as E,
  w1 as F,
  x1 as G,
  n0 as H,
  It as I,
  r0 as J,
  a0 as K,
  z1 as L,
  F1 as M,
  t0 as N,
  Z2 as O,
  C2 as P,
  dt as Q,
  j2 as R,
  de as S,
  xe as T,
  Rt as U,
  H2 as V,
  B2 as W,
  Te as X,
  ht as Y,
  Ct as Z,
  O1 as _,
  L as a,
  Bt as a0,
  jt as a1,
  Ot as a2,
  rt as a3,
  ot as a4,
  qt as a5,
  Ht as a6,
  o1 as b,
  c,
  Y0 as d,
  St as e,
  m2 as f,
  Ge as g,
  P0 as h,
  G0 as i,
  f1 as j,
  c1 as k,
  L1 as l,
  Tt as m,
  D1 as n,
  N1 as o,
  Zt as p,
  Vt as q,
  Et as r,
  Ft as s,
  Ut as t,
  it as u,
  ve as v,
  k0 as w,
  I0 as x,
  he as y,
  ct as z
};
//# sourceMappingURL=Dialog-snEJMtGv.js.map
